import { useLocale } from '~/shared/libs/gatsby-plugin-i18n';
import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { css } from '~/css';
import { useFrontmatter } from '~/shared/contexts/frontmatter';
import type { KeyVisualQuery } from '~/generated/types/gatsby';
import { MOBILE_SCREEN_WIDTH, PC_SCREEN_WIDTH } from '~/constants/screen';
import StoreButtons from '~/components/StoreButtons';
import { rem } from 'polished';

const Wrapper = styled.section({
  zIndex: 1,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
});

const Background = styled(GatsbyImage)(
  css({
    width: '100vw',
    minWidth: [rem(MOBILE_SCREEN_WIDTH), rem(PC_SCREEN_WIDTH)],
  }),
);

const StoreLayout = styled.div({
  position: 'absolute',
  bottom: 0,
  paddingBottom: rem(45),
  width: '100%',
});

function OvensmashKeyVisual() {
  const frontmatter = useFrontmatter();
  const locale = useLocale();

  const data = useStaticQuery<KeyVisualQuery>(graphql`
    query KeyVisual {
      allStrapiGamesiteMain {
        nodes {
          locale
          environment
          game
          mainImageMobile {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, breakpoints: [720], formats: [AUTO, WEBP])
              }
            }
          }
          mainImagePc {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, breakpoints: [3840, 2560, 1920], formats: [AUTO, WEBP])
              }
            }
          }
        }
      }
    }
  `);

  const gameNodes = data.allStrapiGamesiteMain.nodes?.filter(
    (node) => node.environment === (process.env.GATSBY_ENVIRONMENT ?? 'preview') && node.game === frontmatter.gameId,
  );
  const gameNode = gameNodes?.find((node) => node.locale.toLowerCase() === locale.toLowerCase());
  const mainImagePc = gameNode?.mainImagePc!;
  const mainImageMobile = gameNode?.mainImageMobile!;

  return (
    <Wrapper>
      <Background className={'view-pc'} image={getImage(mainImagePc.localFile)!} alt='Ovensmash Key Visual' />
      <Background className={'view-mobile'} image={getImage(mainImageMobile.localFile)!} alt='Ovensmash Key Visual' />

      <StoreLayout>
        <StoreButtons />
      </StoreLayout>
    </Wrapper>
  );
}

export default OvensmashKeyVisual;
